import { SELECT_PEDAL, SET_PEDAL_MODE, SET_PEDAL_CC, SET_PEDAL_CHANNEL } from './actionTypes'

export const selectPedal = (index) => ({ type: SELECT_PEDAL, index: index });
export const setPedalMode = (index, mode) => ({ type: SET_PEDAL_MODE, index: index, mode: mode });
export const setPedalCC = (index, cc) => ({ type: SET_PEDAL_CC, index: index, cc: cc });
export const setPedalChannel = (index, channel) => ({ type: SET_PEDAL_CHANNEL, index: index, channel: channel });
